'use strict';

var _require = require('native-fetch'),
    nativeFetch = _require.default,
    Headers = _require.Headers;
/**
 * Build fetch resource for request.
 *
 * @param {object} properties
 * @param {string} properties.serverResolver
 * @param {string} properties.hostname
 * @param {string} properties.recordType
 * @returns {string}
 */


function buildResource(_ref) {
  var serverResolver = _ref.serverResolver,
      hostname = _ref.hostname,
      recordType = _ref.recordType;
  return "".concat(serverResolver, "?name=").concat(hostname, "&type=").concat(recordType);
}
/**
 * Use fetch to find the record.
 *
 * @param {object} resource
 * @returns {Promise}
 */


function fetch(resource) {
  return nativeFetch(resource, {
    headers: new Headers({
      accept: 'application/dns-json'
    })
  });
}
/**
 * Creates cache key composed by recordType and hostname.
 *
 * @param {string} hostname
 * @param {string} recordType
 * @returns {string}
 */


function getCacheKey(hostname, recordType) {
  return "".concat(recordType, "_").concat(hostname);
}

module.exports = {
  buildResource: buildResource,
  fetch: fetch,
  getCacheKey: getCacheKey
};